export default "__VITE_ASSET__DKVebcWL__"